import React from "react";
import Body from "./Body";
import Requests from "../Requests/Requests";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

const RequestsPage = () => {
  const { token } = useSelector((state) => state.users);

  if (!token) {
    return <Redirect to='/login' />;
  } else {
    return (
      <Body state={2}>
        <Requests />
      </Body>
    );
  }
};

export default RequestsPage;
